import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SharedModule } from '@shared/modules/shared.module';

export type ActionBarType = 'default' | 'download';

export interface ActionBarAction {
	type: 'delete' | 'edit' | 'download' | 'cancel';
	data?: any;
}

@Component({
	selector: 'app-selection-action-bar',
	imports: [SharedModule, ButtonComponent],
	templateUrl: './selection-action-bar.component.html',
	styleUrl: './selection-action-bar.component.scss',
})
export class SelectionActionBarComponent {
	@Input() type: ActionBarType = 'default';
	@Input() selectedCount: number = 0;
	@Input() showEditButton: boolean = false; // Only for single selection

	@Output() onAction = new EventEmitter<ActionBarAction>();

	handleDelete(): void {
		this.onAction.emit({ type: 'delete' });
	}

	handleEdit(): void {
		this.onAction.emit({ type: 'edit' });
	}

	handleDownload(): void {
		this.onAction.emit({ type: 'download' });
	}

	handleCancel(): void {
		this.onAction.emit({ type: 'cancel' });
	}
}
